import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import SidebarWOdetails from "./sidebarWOdetails";
import { useChecklistApi } from "../../../store/api/hooks/checklistApiHook";
import { useWorkOrderApi } from "../../../store/api/hooks/workOrderApiHook";
import { titleCell } from "../../../components/elements/function";
import Icon from "../../../components/icons";
import { AgGridReact } from 'ag-grid-react';
import Loader from "../../../components/loader";
import { Controller, useForm } from 'react-hook-form';
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import toast from "react-hot-toast";
import moment from "moment";
import Button from "../../../components/elements/button";
import Signaturepad from "../../../components/signaturepad";
import Timepicker from "../../../components/elements/form/timePicker";

interface Props {
  workorder?: any;
};
type formComponentTypes = 'checkbox' | 'text-field' | 'yes-no-na' | 'number-field' | 'inspection' | 'multiple-choice' | 'amount' | 'checklist' | 'picture-file' | 'signature' | 'date' | `time`;

const TasksWOdetails: React.FC<Props> = ({ workorder }) => {
  const params: any = useParams();
  const checklistAPI: any = useChecklistApi();
  const workOrderAPI: any = useWorkOrderApi();


  const inputRef: any = useRef();
  const dragarea: any = useRef();
  const [imagePreview, setImagePreview] = React.useState<string[]>([]);

  const [selectdFilessource, setSelectedFilesSource] = React.useState<any>([]);
  const [signatureFile, setSignatureFile] = React.useState<any>(null);

  const { showLoader, hideLoader } = useAppLoader();

  const checklistagrid: any = useRef();

  const [gridApi, setGridApi] = useState<any>(null);
  const [gridColumnApi, setGridColumnApi] = useState<any>(null);


  const [unbindchecklist, setUnbindChecklist] = useState<any>(null);
  const [checklist, setChecklist] = useState<any>([]);
  const [selectedChecklist, setSelectedChecklist] = useState<any>(null);

  const inputIDS: formComponentTypes[] = ['checkbox', 'text-field', 'yes-no-na', 'number-field', 'inspection', 'multiple-choice', 'amount', 'checklist', 'picture-file', 'signature', 'date', `time`];
  const { control, register, handleSubmit, formState: { errors }, reset } = useForm();


  const checklistColumnDefs = [
    {
      headerName: 'Checklist No', field: 'checkListCode', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: (data: any) => {
        return (
          <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>
        )
      }, onCellClicked: (param: any) => {
      }
    },
    { headerName: 'Title ', field: 'checkListTitle', headerClass: 'bg-[#f0f0f0]', width: 300, cellRenderer: titleCell },
    { headerName: 'Description', field: 'checkListDesc', headerClass: 'bg-[#f0f0f0]', flex: 1, width: 160, cellRenderer: titleCell },
    { headerName: 'Type', field: 'checkListTypeName', headerClass: 'bg-[#f0f0f0]', minWidth: 160, cellRenderer: titleCell },
    /*
    {
        headerName: "Actions",
        field: "actions",
        headerClass: 'bg-[#f0f0f0] text-center',
        width: 90,
        cellRenderer: (params: any) => {
            return (
                <div className='relative h-full w-full flex items-center justify-center'>
                    <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                        e.stopPropagation();
                        e.preventDefault();
                        const dropdown: any = document.querySelector('.action-dropdown');
                        if (dropdown) {
                            dropdown.focus();
                        }
                        return false;
                    }} />
                    <select
                        onChange={(e) => {
                            handleActionChange(e, params);
                            //e.target.value = '';
                        }}
                        onFocus={(e) => {
                            e.target.selectedIndex = -1;
                        }
                        }
                        className="action-dropdown"
                        value={''}
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            opacity: 0,
                            cursor: "pointer",
                        }}
                    >
                        <option value="complete">Complete</option>
                    </select>
                </div>
            );
        }
    }*/
  ];

  const onGridReady = (params: any) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };
  const onRowClicked = (event: any) => {
    showTasksOfChecklist(event.data);
    if (!event.event.target.closest('input[type="checkbox"]')) {
      event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
    }
  };
  const getSelectedRows = () => {
    const selectedNodes = gridApi?.getSelectedNodes();
    const selectedData = selectedNodes.map((node: any) => node.data);
    return selectedData;
  };

  const getNewComponent = (formComponent: formComponentTypes, taskid: any) => {
    //const ID = 'field_' + (new Date().getTime() + Math.random()).toString();
    const ID = `field_${taskid}`;
    let newCard: any = { id: ID, component: formComponent };
    switch (formComponent) {
      case 'checkbox':
        newCard = { ...newCard, type: 'checkbox', label: 'CheckBox', name: ID, options: ['Option 1'], customize: false, optionEditable: true };
        break;
      case 'text-field':
        newCard = { ...newCard, type: 'text', label: 'Text Field', name: ID, placeholder: 'Enter text' };
        break;
      case 'yes-no-na':
        newCard = { ...newCard, type: 'radio', label: 'Yes, No, Not Applicable', name: ID, options: [{ woTaskOptionID: '0', optionName: 'Yes' }, { woTaskOptionID: '1', optionName: 'No' }, { woTaskOptionID: '2', optionName: 'Not Applicable' }], customize: false, optionEditable: false };
        break;
      case 'number-field':
        newCard = { ...newCard, type: 'number', label: 'Number Field', name: ID, placeholder: 'Enter number' };
        break;
      case 'inspection':
        newCard = { ...newCard, type: 'radio', label: 'inspection', name: ID, options: [{ woTaskOptionID: '0', optionName: 'Pass' }, { woTaskOptionID: '1', optionName: 'Fail' }, { woTaskOptionID: '2', optionName: 'Flag' }], customize: false, optionEditable: false };
        break;
      case 'multiple-choice':
        newCard = { ...newCard, type: 'radio', label: 'Multiple Choice', name: ID, options: [{ woTaskOptionID: 'Option 1', optionName: 'Option 1' }, { woTaskOptionID: 'Option 2', optionName: 'Option 2' }, { woTaskOptionID: 'Option 3', optionName: 'Option 3' }], customize: true, optionEditable: true };
        break;
      case 'amount':
        newCard = { ...newCard, type: 'number', label: 'Amount', name: ID, placeholder: 'Enter amount', icon: 'price-change' };
        break;
      case 'checklist':
        newCard = { ...newCard, type: 'checkbox', label: 'Checklist', name: ID, options: [{ woTaskOptionID: 'Item 1', optionName: 'Item 1' }, { woTaskOptionID: 'Item 2', optionName: 'Item 2' }, { woTaskOptionID: 'Item 3', optionName: 'Item 3' }], customize: true, optionEditable: true };
        break;
      case 'picture-file':
        newCard = { ...newCard, type: 'file', label: 'Picture/File', name: ID, accept: 'image/*', multiple: true };
        break;
      case 'signature':
        newCard = { ...newCard, type: 'signature', label: 'Signature Block', name: ID };
        break;
      case 'date':
        newCard = { ...newCard, type: 'date', label: 'Date', name: ID, placeholder: 'Select date' };
        break;
      case 'time':
        newCard = { ...newCard, type: 'time', label: 'Date', name: ID, placeholder: 'Select Time' };
        break;
      default:
        newCard = null;
    }
    return newCard;
  }

  const getFormComponent = (card: any) => {
    switch (card.type) {
      case 'checkbox':
        return <div className={`flex gap-4 items-center border-b border-gray-200 py-4 px-4`} style={{ minHeight: `80px` }}>
          <div style={{ minWidth: 400, maxWidth: 400, width: 400 }}><label style={{ fontSize: `15px`, color: `#767676` }}>{card.label}</label></div>
          <div className={`flex flex-wrap gap-4`}>
            {card.options.map((option: any, index: number) => (
              <label className='flex gap-2 custom-dx-radio' key={`${card.id}-${index}`}>
                <input type="checkbox" {...register(card.id)} value={option.woTaskOptionID} />
                <span>{option.optionName}</span>
              </label>
            ))}
          </div>
        </div>;
      case 'text':
        return <div className={`flex gap-4 items-center border-b border-gray-200 py-4 px-4`} style={{ minHeight: `80px` }}>
          <div style={{ minWidth: 400, maxWidth: 400, width: 400 }}><label style={{ fontSize: `15px`, color: `#767676` }}>{card.label}</label></div>
          <input type="text" {...register(card.id)} placeholder="Enter text" className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] mt-2 pl-2 py-1 font-xs h-[2rem] w-full' />
        </div>
      case 'radio':
        return <div className={`flex gap-4 items-center border-b border-gray-200 py-4 px-4`} style={{ minHeight: `80px` }}>
          <div style={{ minWidth: 400, maxWidth: 400, width: 400 }}><label style={{ fontSize: `15px`, color: `#767676` }}>{card.label}</label></div>
          <div className={`flex gap-4`}>
            {card.options.map((option: any, index: number) => (
              <label className='flex gap-3 custom-dx-radio' key={`${card.id}-${index}`}>
                <input type="radio" {...register(card.id)} value={option.woTaskOptionID} />
                <span>{option.optionName}</span>
              </label>
            ))}
          </div>
        </div>
      case 'number':
        return <div className={`flex gap-4 items-center border-b border-gray-200 py-4 px-4`} style={{ minHeight: `80px` }}>
          <div style={{ minWidth: 400, maxWidth: 400, width: 400 }}><label style={{ fontSize: `15px`, color: `#767676` }}>{card.label}</label></div>
          {card.component === 'amount' ? (
            <div className='flex grow items-center gap-2'>
              <span>$</span><input type="number" step="any" {...register(card.id)} placeholder="Enter Amount" className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] mt-2 pl-2 py-1 font-xs h-[2rem] w-full' />
            </div>
          ) : <input type="number" step="any" {...register(card.id)} placeholder="Enter numeric value" className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] mt-2 pl-2 py-1 font-xs h-[2rem] w-full' />}
        </div>
      case 'file':
        return <div className={`flex gap-4 items-start border-b border-gray-200 py-4 px-4`} style={{ minHeight: `80px` }}>
          <div style={{ minWidth: 400, maxWidth: 400, width: 400 }}><label style={{ fontSize: `15px`, color: `#767676` }}>{card.label}</label></div>
          <div className={`grow`}>
            <input type="hidden" {...register(card.id)} className={'w-full'} />
            <div ref={dragarea} className="flex items-center justify-center w-full rounded-md cursor-pointer hover:border-gray-600 transition p-3" style={{ border: `1px dashed #9099A1`, marginTop: `13px` }} onDragOver={(e) => {
              dragarea.current.style.borderColor = `#2b5a2e`; // Change border color on drag over
              e.preventDefault(); // Required to allow drop                             
            }} onDrop={(e: any) => {
              e.preventDefault();
              dragarea.current.style.borderColor = `#9099A1`; // Change border color on drag over
              const files: any = e.dataTransfer.files;
              if (files) {
                let preview: any = [];
                let sourcefiles: any = [];
                let refinesourcefiles: any = [];
                //const allowedExt = ['jpg', 'jpeg', 'png', 'gif']; // Allowed file extensions
                const allowedExt: any = [];

                console.log('file type-----', files[0].type);
                let file = files[0];
                var ext = file.name.split('.').pop();
                if (allowedExt.length > 0 && !allowedExt.includes(ext.toLowerCase())) {
                  toast.error(`${file.name} - File type not allowed. Allowed types are: ${allowedExt.join(', ')}`);
                }

                if (file.type.startsWith('image/')) {
                  let reader: any = new FileReader();
                  reader.onloadend = () => {
                    preview = [...preview, { name: file.name, mimetype: files[0].type, ext: file.name.split('.').pop(), src: reader.result }];
                    setImagePreview(preview);
                  };
                  reader.readAsDataURL(file);
                } else {
                  preview.push({ name: file.name, mimetype: files[0].type, ext: ext, src: null });
                }
                refinesourcefiles.push({ source: file, identifier: card.id });
                sourcefiles = [...sourcefiles, ...refinesourcefiles];
                setImagePreview(preview);
                setSelectedFilesSource(sourcefiles);
              }
            }}>
              <div className="text-gray-600 flex items-center justify-between grow">
                <Button theme={`light`} className={`text-center`} customstyle={{ width: `50%`, height: `44px` }} childstyle={{ justifyContent: `center`, fontSize: `15px`, fontWeight: `normal` }} onClick={() => {
                  if (inputRef.current) {
                    inputRef.current.click();
                  }
                }}>Upload</Button>
                <div style={{ width: `50%`, color: `#757C84`, textAlign: `center`, fontSize: `15px` }}>or Drop Files</div>
              </div>
            </div>
            <input
              ref={inputRef}
              type="file"
              multiple={false}
              placeholder={`Select file for upload`}
              onChange={(e: any) => {
                const files = e.target.files

                if (files) {
                  let preview: any = [];
                  let sourcefiles: any = [];
                  let refinesourcefiles: any = [];
                  const allowedExt: any = []; // Allowed file extensions

                  let file = files[0];
                  var ext = file.name.split('.').pop();
                  if (allowedExt.length > 0 && !allowedExt.includes(ext.toLowerCase())) {
                    toast.error(`${file.name} - File type not allowed. Allowed types are: ${allowedExt.join(', ')}`);
                  }
                  if (file.type.startsWith('image/')) {
                    let reader: any = new FileReader();
                    reader.onloadend = () => {
                      //preview = [...preview, reader.result];
                      //preview = [...preview, {name: file.name, mimetype: files[0].type, ext: file.name.split('.').pop(), src: reader.result}];
                      preview = [{ name: file.name, mimetype: files[0].type, ext: file.name.split('.').pop(), src: reader.result }];
                      setImagePreview(preview);
                    };
                    reader.readAsDataURL(file);
                  } else {
                    //preview.push('file');
                    preview.push({ name: file.name, mimetype: files[0].type, ext: ext, src: null });
                  }
                  refinesourcefiles.push({ source: file, identifier: card.id, mode: `attachment` });
                  sourcefiles = [...sourcefiles, ...refinesourcefiles];
                  setImagePreview(preview);
                  setSelectedFilesSource(sourcefiles);
                }
              }}
              className={`pl-4 py-2 rounded-md focus:outline-none  focus:primary text-[0.938rem] mt-2 font-normal min-h-[2.875rem] text-[#656565] w-full placeholder:text-[#656565] hidden`}
            />
            {imagePreview.length > 0 && (
              <div className={`flex flex-wrap gap-2 mt-2`}>
                <div style={{ borderRadius: `8px`, overflow: `hidden` }} className={`w-full border-collapse border border-gray-300`}>
                  <table style={{ width: '100%' }} className={`table-auto`}>
                    <thead>
                      <tr style={{ backgroundColor: '#F0F0F0' }}>
                        <th className={`text-left text-[0.813rem] font-medium`} style={{ padding: `8px 10px` }}>File Name</th>
                        <th className={`text-right text-[0.813rem] font-medium`}>File type</th>
                        <th className={`text-right text-[0.813rem] font-medium`}>Extension</th>
                      </tr>
                    </thead>
                    <tbody>
                      {imagePreview.map((img: any, i: number) => (
                        <tr key={i} style={{ backgroundColor: i % 2 === 0 ? '#FFFFFF' : '#F6F6F6' }}>
                          <td className={`text-[0.813rem]`} style={{ padding: `5px 10px` }}>
                            <div className={`flex items-center gap-2 font-normal`}>
                              {[`png`, `jpg`, `jpeg`, `gif`, `webp`].includes(img.ext.toLowerCase()) ? (
                                <div className='rounded-md' style={{ backgroundImage: `url(${img.src})`, backgroundSize: 'cover', backgroundPosition: 'center', width: 42, height: 42 }}></div>
                              ) : (
                                <Icon name='file' size={2} className='text-[#656565]' />
                              )}
                              <div>{img.name}</div>
                            </div>
                          </td>
                          <td className={`text-right text-[0.813rem] font-normal`} style={{ padding: `5px 10px` }}>{img.mimetype}</td>
                          <td className={`text-right text-[0.813rem] font-normal`} style={{ padding: `5px 10px` }}>{img.ext.toUpperCase()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            {card.file && (
              <div className={`flex py-2 text-[0.813rem] text-primary text-center relative`}>

                <Link to={card.file.fullFilePath} target="_blank">
                  {[`png`, `jpg`, `jpeg`, `gif`].includes(card.file.originalFileName.split('.').pop().toLowerCase()) ? (
                    <img src={card.file.fullFilePath} alt={card.file.originalFileName} className={`w-28 h-24 rounded object-cover object-center`} />
                  ) : (
                    <div className={`w-36 h-28 flex items-center justify-center flex-col border border-primary p-2 rounded`}>
                      <span className={`block mb-2 text-center`}><Icon name={`attachmentfile`} size={2} /></span>
                      <span className={`block w-full whitespace-nowrap overflow-hidden text-ellipsis`} title={card.file.originalFileName}>{card.file.originalFileName}</span>
                    </div>
                  )}
                </Link>

                {/*
                <Link to={card.file.fullFilePath} target="_blank">                  
                    <div className={ `w-36 h-28 flex items-center justify-center flex-col border border-primary p-2 rounded` }>
                      <span className={ `block mb-2 text-center` }><Icon name={ `attachmentfile` } size={2} /></span>
                      <span className={ `block w-full whitespace-nowrap overflow-hidden text-ellipsis` } title={ card.file.originalFileName }>{ card.file.originalFileName }</span>
                    </div>                  
                </Link>
                */}
                {/* <span className='text-sm text-gray-400 inline-block ms-1'>({item.fileSize})</span> */}
              </div>
            )}
          </div>
          {/*
          <div className='border-[#CECECE] border p-3 disabled-x w-full' style={{ color: `#555` }}>
            <input type="file" accept="image/*" multiple={card.multiple} /> 
          </div>
          */}
        </div>
      case 'signature':
        return <div className={`flex gap-4 items-center border-b border-gray-200 py-4 px-4`}>
          <div style={{ minWidth: 400, maxWidth: 400, width: 400 }}><label style={{ fontSize: `15px`, color: `#767676` }}>{card.label}</label></div>
          <input type="hidden" {...register(card.id)} className={'w-full'} />
          <div className='flex items-center w-full'>
            {[`1`, `7`, `2`, `4`].includes((`` + workorder?.woStatusID)) ? (
              <Signaturepad
                className={`!my-0`}
                isHideLabel={true}
                displaySignature={card.file ? card.file.fullFilePath : null}
                onClear={() => {
                  console.log("Signature cleared");
                  setSignatureFile(null);
                }}
                onComplete={(data, file) => {
                  console.log("Signature completed", data);
                  console.log("Signature File -> ", file);

                  setSignatureFile({ source: file, identifier: card.id, mode: `sign` });
                }}
              />
            ) : (
              <img src={card.file.fullFilePath} alt={card.file.originalFileName} className={`w-52 rounded`} />
            )}
          </div>
        </div>
      case 'date':
        return <div className={`flex gap-4 items-center border-b border-gray-200 py-4 px-4`} style={{ minHeight: `80px` }}>
          <div style={{ minWidth: 400, maxWidth: 400, width: 400 }}><label style={{ fontSize: `15px`, color: `#767676` }}>{card.label}</label></div>
          <input type="date" {...register(card.id)} className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] pl-2 py-1 font-xs h-[2rem] w-full' />
        </div>;
      case 'time':
        return <div className={`flex gap-4 items-center border-b border-gray-200 py-4 px-4`} style={{ minHeight: `80px` }}>
          <div style={{ minWidth: 400, maxWidth: 400, width: 400 }}><label style={{ fontSize: `15px`, color: `#767676` }}>{card.label}</label></div>
          <Controller
            name={card.id}
            control={control}
            render={({ field: { value, onChange } }) => (
              <Timepicker
                label=""
                className={`!my-0`}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {/*
          <input type="time" {...register(card.id)} id={card.id} className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] px-2 py-1 font-xs min-h-[46px] w-full rounded' />
          */}
        </div>;
      default:
        return null;
    }
  };

  const init_page_date = async () => {
    showLoader();
    const activityresp: any = await new Promise((resolve, reject) => {
      workOrderAPI.GetWOTasks({ workOrderID: workorder.workOrderID }, (resp: any) => {
        //console.log("Activity response is -> ", resp);
        if (resp && resp.hasOwnProperty(`tasks`) && Array.isArray(resp.tasks) && resp.tasks.length > 0) {
          //console.log("exec here", resp.tasks.map((item:any) => item.checkListID));
          const newresp = Object.assign([], JSON.parse(JSON.stringify(resp)));
          setUnbindChecklist(newresp);
          const bindchecklist = resp.tasks.filter((item: any, index: number, self: any) => index === self.findIndex((t: any) => t.checkListID == item.checkListID)).map((o: any) => {
            return {
              checkListID: o.checkListID,
              checkListCode: o.checkListCode,
              checkListTitle: o.checkListTitle,
              checkListDesc: o.checkListDesc,
              checkListTypeName: o.checkListTypeName,
              checkListTypeID: o.checkListTypeID,
              tasks: resp.tasks.filter((task: any) => task.checkListID == o.checkListID).map((task: any) => {
                console.log("task is from map -> ", task);
                let formComponent: formComponentTypes = inputIDS[task.inputTypeID - 1];
                console.log('formComponent', formComponent);
                var newCard: any = getNewComponent(formComponent, task.woTaskID);
                newCard.label = task.inputLabel;
                newCard.checkListTaskID = task.woTaskID; // Assuming checkListTaskID is unique
                newCard.sortOrder = task.sortOrder;
                if (newCard) {
                  switch (formComponent) {
                    case 'checkbox':
                      newCard.options = task.options;
                      break;
                    case 'multiple-choice':
                    case 'checklist':
                      newCard.options = task.options;
                      break;
                    case `picture-file`:
                      if (resp.tasksFiles && Array.isArray(resp.tasksFiles) && resp.tasksFiles.length > 0) {
                        const attachment = resp.tasksFiles.find((att: any) => (att.woTaskID == task.woTaskID && att.inputTypeID == task.inputTypeID));
                        if (attachment) {
                          newCard[`file`] = attachment;
                        }
                      }
                      break;
                    case `signature`:
                      if (resp.tasksFiles && Array.isArray(resp.tasksFiles) && resp.tasksFiles.length > 0) {
                        const attachment = resp.tasksFiles.find((att: any) => (att.woTaskID == task.woTaskID && att.inputTypeID == task.inputTypeID));
                        if (attachment) {
                          newCard[`file`] = attachment;
                        }
                      }
                      break;

                  }

                }
                return newCard;
              })
            }
          });
          resolve(bindchecklist || []);
        } else {
          resp.tasks = [];
          resolve([]);
        }
      }, (error: any) => {
        console.log("error =>", error);
        reject([]);
      });
    }).catch((error: any) => {
      hideLoader();
      return [];
    });
    setChecklist(activityresp);
    hideLoader();
    //showTasksOfChecklist(activityresp[0]);
    console.log("Activity response is -> ", activityresp);
  };

  const handleActionChange = (e: any, params: any) => {
    e.stopPropagation();
    e.preventDefault();
    if (e.target.value === "complete") {
      // Handle the edit action here
      showTasksOfChecklist(params.data);
      // You can navigate to the edit page or perform any other action
    }
  };

  const updateAGgrid = async (data: any) => {
    if ([`1`, `2`, `4`].includes((`` + workorder?.woStatusID))) {
      if (data) {
        checklistagrid.current.api.forEachNode((node: any) => {
          if (node.data && +node.data.checkListID === +data.checkListID) {
            node.setSelected(true);
          } else {
            node.setSelected(false);
          }
        });
      }
    }
  };

  const showTasksOfChecklist = (data: any) => {
    setSelectedChecklist(null);
    reset({});
    setTimeout(async () => {
      setSelectedChecklist(data);
      const formjson: any = {};
      for await (const task of data.tasks) {
        const dbtaskID = task.id.split('_')[1];
        const field = unbindchecklist.tasks.find((x: any) => (x.woTaskID == dbtaskID && x.checkListID == data.checkListID));
        switch (task.component) {
          case `checkbox`:
          case `multiple-choice`: {
            const chkitm = field.options.find((o: any) => o.isChecked);
            if (chkitm) {
              formjson[task.id] = chkitm.woTaskOptionID ? `` + chkitm.woTaskOptionID : ``;
            }
            break;
          }
          case `yes-no-na`: {
            formjson[task.id] = field.yesNoOption !== null && field.yesNoOption !== undefined ? `` + field.yesNoOption : ``;
            break;
          }
          case `inspection`: {
            formjson[task.id] = field.inspectionStatus !== null && field.inspectionStatus !== undefined ? `` + field.inspectionStatus : ``;
            break;
          }
          case `checklist`: {
            formjson[task.id] = field.options.filter((o: any) => o.isChecked).map((o: any) => `` + o.woTaskOptionID);
            break;
          }
          case `text-field`: {
            formjson[task.id] = field.textResponse ? field.textResponse : ``;
            break;
          }
          case `number-field`: {
            formjson[task.id] = field.numberValue !== null && field.numberValue !== undefined ? field.numberValue : '';
            break;
          }
          case `amount`: {
            formjson[task.id] = field.amount !== null && field.amount !== undefined ? field.amount : '';
            break;
          }
          case `date`: {
            formjson[task.id] = field.dateValue ? moment(field.dateValue, ['YYYY-MM-DD', 'MM/DD/YYYY']).format(`YYYY-MM-DD`) : ``;
            break;
          }
          case `time`: {
            formjson[task.id] = field.dateValue ? moment.utc(field.dateValue, `YYYY-MM-DD HH:mm:ss `).local() : null; //;
            break;
          }
        }
      }
      reset(formjson);
      updateAGgrid(data);
    }, 100);
    console.log("Selected checklist data is -> ", data);
  };

  const onSubmitTaskForm = async (data: any) => {
    if (workorder) {
      const payload: any = {
        workOrderID: workorder.workOrderID,
        refCheckListID: selectedChecklist.checkListID,
        tasks: []
      };
      var bindtasks = Object.keys(data).map((key: string) => {
        const dbtaskID = key.split('_')[1];
        const value = data[key];
        var model: any = null;
        const field = unbindchecklist.tasks.find((task: any) => (task.woTaskID == dbtaskID && task.checkListID == selectedChecklist.checkListID));
        const parsefield = selectedChecklist.tasks.find((task: any) => (task.id == key));
        if (field && parsefield) {
          model = {
            woTaskID: dbtaskID,
            title: field.title,
            inputLabel: field.inputLabel,
            inputTypeID: field.inputTypeID,
            isRequired: field.isRequired,
            sortOrder: field.sortOrder,
            textResponse: ``,
            yesNoOption: ``,
            inspectionStatus: ``, //inspection
            refCheckListID: field.checkListID,
            amount: ``, //amount 
            dateValue: ``, //date
            numberValue: ``, //number
            woTaskOptions: [] //checkbox/radio//multiselect
          };
          let formComponent: formComponentTypes = inputIDS[field.inputTypeID - 1];
          switch (formComponent) {
            case 'checkbox':
            case 'multiple-choice': {
              model.woTaskOptions = model.woTaskOptions = parsefield.options.map((o: any) => {
                o.isChecked = (value == (`` + o.woTaskOptionID)) ? true : false;
                return o;
              });
              break;
            }
            case 'checklist': {
              if (Array.isArray(value) && value.length > 0) {
                model.woTaskOptions = parsefield.options.map((o: any) => {
                  o.isChecked = value.indexOf(`` + o.woTaskOptionID) > -1 ? true : false;
                  return o;
                });
              }
              break;
            }
            case 'text-field': {
              model.textResponse = value;
              break;
            }
            case 'yes-no-na': {
              model.yesNoOption = value ? value : null;
              break;
            }
            case 'inspection': {
              model.inspectionStatus = value;
              break;
            }
            case 'amount': {
              model.amount = value;
              break;
            }
            case 'number-field': {
              model.numberValue = value;
              break;
            }
            case 'date': {
              if (value)
                model.dateValue = moment(value, 'YYYY-MM-DD').format('MM/DD/YYYY');
              else
                model.dateValue = null;
              break;
            }
            case 'time': {
              if (value) {
                const copymomentobj = value.clone();
                model.dateValue = value && copymomentobj ? copymomentobj.utc().toISOString() : null;
              } else {
                model.dateValue = null;
              }
              break;
            }
            case 'picture-file':
            case 'signature': {
              model.textResponse = field.textResponse;
              model.yesNoOption = field.yesNoOption;
              model.inspectionStatus = field.inspectionStatus;
              model.amount = field.amount;
              model.numberValue = field.numberValue;
              model.dateValue = field.dateValue;
              model.woTaskOptions = [];
              break;
            }
          }
        }
        return model;
      });
      payload.tasks = bindtasks;
      console.log("Form data is -> ", data);
      console.log("Payload is -> ", payload);
      //return false;
      showLoader();
      const saveresp: any = await new Promise((resolve, reject) => {
        workOrderAPI.SaveWorkOrderTasks(payload, (resp: any) => {
          console.log("Response from update tasks is -> ", resp);
          resolve(resp);
        }, (error: any) => {
          toast.error(error);
          reject(error);
        });
      }).catch((error: any) => {
        return null;
      });
      hideLoader();

      if (saveresp && saveresp.hasOwnProperty('code') && saveresp.code == 200 && saveresp.hasOwnProperty('successful') && saveresp.successful) {
        toast.success(saveresp.message);

        //File uploading
        if (selectdFilessource.length > 0) {
          showLoader();
          const taskattchmentdata = new FormData();
          taskattchmentdata.append('WorkOrderID', workorder.workOrderID);
          for await (const file of selectdFilessource) {
            const dbtaskID = file.identifier.split('_')[1];
            const field = unbindchecklist.tasks.find((task: any) => (task.woTaskID == dbtaskID && task.checkListID == selectedChecklist.checkListID));
            console.log("Field is -> ", field);
            if (field) {
              taskattchmentdata.append('InputFile', file.source);
              taskattchmentdata.append('WorkOrderTaskID', dbtaskID);
              taskattchmentdata.append('TaskInputType', field.inputTypeID);
            }
          }
          console.log("Task attachment data is -> ", taskattchmentdata);
          const filerespx: any = await new Promise((resolve, reject) => {
            workOrderAPI.SaveWOTaskAttachments(taskattchmentdata, (resp: any) => {
              console.log("Response from update tasks is -> ", resp);
              toast.success(resp.message);
              resolve(resp);
            }, (error: any) => {
              toast.error(error);
              reject(error);
            });
          }).catch((error: any) => {
            return null;
          });
          hideLoader();
        }

        //Signature file uploading
        if (signatureFile) {
          showLoader();
          const tasksignaturedata = new FormData();
          tasksignaturedata.append('WorkOrderID', workorder.workOrderID);
          const dbtaskID = signatureFile.identifier.split('_')[1];
          const field = unbindchecklist.tasks.find((task: any) => (task.woTaskID == dbtaskID && task.checkListID == selectedChecklist.checkListID));
          if (field) {
            tasksignaturedata.append('SignatureFile', signatureFile.source);
            tasksignaturedata.append('WorkOrderTaskID', dbtaskID);
            tasksignaturedata.append('TaskInputType', field.inputTypeID);
          }
          const filerespx: any = await new Promise((resolve, reject) => {
            workOrderAPI.SaveWOTaskAttachments(tasksignaturedata, (resp: any) => {
              console.log("Response from update tasks is -> ", resp);
              toast.success(resp.message);
              resolve(resp);
            }, (error: any) => {
              toast.error(error);
              reject(error);
            });
          }).catch((error: any) => {
            return null;
          });
          hideLoader();
        }


        setSelectedChecklist(null);
        setSignatureFile(null);
        setSelectedFilesSource([]);
        setImagePreview([]);
        reset({});
        init_page_date();
      }
      console.log("Save response is -> ", saveresp);
    }
  }


  useEffect(() => {
    if (workorder) {
      init_page_date();
    }
    return () => {
      // Reset state or run cleanup
      setSelectedChecklist(null); // will only work if the component remounts later
      setUnbindChecklist(null);
      setChecklist([]);
      setGridColumnApi(null);
      setGridApi(null);
    };
  }, []);


  return (
    <div className="flex">
      <div className="flex-grow border-r border-gray-200 pt-4">
        <div className="ag-theme-alpine mr-4">
          <AgGridReact
            ref={checklistagrid}
            columnDefs={checklistColumnDefs} // Pass columnDefs
            rowData={checklist || []} // Pass rowData
            pagination={false}
            rowSelection="single"
            onGridReady={onGridReady}
            domLayout="autoHeight"
            onRowClicked={onRowClicked}
            loadingOverlayComponent={Loader}
            noRowsOverlayComponent={() => (
              <div className="flex items-center justify-center h-full">
                <div className="text-center text-gray-500">
                  <div className="text-lg font-medium">No Data Found</div>
                </div>
              </div>
            )}
            getRowClass={(params: any) => {
              if (params.data && params.data.checkListID === selectedChecklist?.checkListID) {
                params.node.setSelected(true);
              }
              return ``;
            }}
          />
        </div>
        {selectedChecklist && (
          <div className={`mt-4 mr-4`} style={{ border: `1px solid #e5e7eb`, borderRadius: `8px`, overflow: `hidden` }}>
            <h4 className="font-semibold text-[0.938rem] mb-2 px-4 py-4" style={{ background: `#eeeeee` }}>Tasks for Checklist: {selectedChecklist.checkListTitle}</h4>
            <form name="dynamictaskform" onSubmit={handleSubmit(onSubmitTaskForm)}>
              {selectedChecklist.tasks.map((card: any, index: number) => (
                <div key={card.id} className={`dx-wo-chk-tsk ${[`3`, `5`, `6`].includes((`` + workorder?.woStatusID)) ? `pointer-events-none` : ``}`}>
                  {getFormComponent(card)}
                </div>
              ))}
              <div className={"flex justify-end gap-2 mt-4"}>
                {
                  [`1`, `7`, `2`, `4`].includes((`` + workorder?.woStatusID)) && (<button type="submit" className="btn btn-primary" style={{ width: 225 }}>Save</button>)
                }
                <button type="button" className="btn btn-secondary" onClick={() => {
                  reset({});
                  setSelectedChecklist(null);
                  checklistagrid.current.api.forEachNode((node: any) => {
                    node.setSelected(false);
                  });
                }} style={{ width: 150 }}>Cancel</button>
              </div>
            </form>
          </div>
        )}


      </div>
      <div className="p-[1.125rem] flex-grow-0 flex-shrink-0" style={{ width: `312px` }}>
        <SidebarWOdetails workorder={workorder} />
      </div>
    </div>
  );
};

export default TasksWOdetails;
